import React, { useContext, useState } from "react";
import PreviewForm from "./PreviewForm";
import AppContext from "../../../context/AppContext";
import CommonButton from "../../../components/common/CommonButton";
import translations from "../../../components/common/Translations";
import ModalCloseButton from "../../../components/common/ModalCloseButton";
import { isRTL } from "../../../utils/rtl";

const Modal = ({
  onClose,
  previewData,
  page,
  isPageWise,
  linkedWorkflowOptions,
}) => {
  console.log(previewData)
  const [currentPage, setCurrentPage] = useState(1);
  const { theme, langMode } = useContext(AppContext)
  const isRtl = isRTL(langMode);
  const totalPages = Math.max(Number(page) || 1, 1);
  const pageWiseEnabled =
    isPageWise === true || isPageWise === "true" || totalPages > 1;
  const nextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  const previousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };
  return (
    <div className="fixed top-0 left-0 z-50 w-full h-full flex justify-center items-center bg-black bg-opacity-50 backdrop-blur-sm">
      <div
        className={`bg-white rounded-lg p-8 relative border border-gray-400 ${theme === "dark"
            ? "dark-mode "
            : theme === "high-contrast"
              ? "high-contrast"
              : ""
          }`}
        style={{ width: "550px" }}
      >
        {pageWiseEnabled && (
          <span className={`absolute top-0 m-4 text-sm text-gray-700 ${isRtl ? "right-0" : "left-0"}`}>
            Page :{currentPage}
          </span>
        )}
        <ModalCloseButton
          className={`absolute top-0 m-4 ${isRtl ? "left-0" : "right-0"}`}
          onClick={onClose}
        />
        <div className=" overflow-y-auto h-[350px] my-5 ">
          <PreviewForm
            fields={Array.isArray(previewData) ? previewData : []}
            totalPages={totalPages}
            currentPage={currentPage}
            isPageWise={pageWiseEnabled}
            linkedWorkflowOptions={linkedWorkflowOptions}
          />
        </div>
        {pageWiseEnabled && (
          <div className="mt-10 flex justify-end items-center gap-3">
            <CommonButton colorIntent="primary"
              onClick={previousPage}
              variant="primary"
              tooltipText={translations[langMode].gotopreviouspage}
              tooltipPosition="left"
              disabled={currentPage === 1}
            >
              {translations[langMode].Back}
            </CommonButton>
            <CommonButton colorIntent="primary"
              onClick={nextPage}
              variant="success"
              tooltipText={translations[langMode].gotonextpage}
              tooltipPosition="left"
            >
              {translations[langMode].next}
            </CommonButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
